import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TextInput from '@narvar/nth-text-input';
import Spinner from '@narvar/nth-spinner';
import { outline } from '@narvar/nth-button';
import { FormDescription, FormInnerWrapper, FormOuterWrapper, Submit } from './styles';

const mapStateToProps = ({ language }) => ({ language });

export const FormContentComponent = ({
  language,
  showTwoFa,
  handleChangeTwoFa,
  secondFactorInput,
  twoFaType,
  handleChangeOrder,
  orderNumber,
  handleSubmit,
  loading,
}) => {
  if (loading) {
    return (
      <FormOuterWrapper>
        <FormDescription>{language['returns.items.multi_item_form.description']}</FormDescription>
        <Spinner />
      </FormOuterWrapper>
    );
  }

  return (
    <FormOuterWrapper>
      <FormDescription>{language['returns.items.multi_item_form.description']}</FormDescription>
      <FormInnerWrapper>
        {showTwoFa && (
          <TextInput
            type="text"
            onChange={handleChangeTwoFa}
            value={secondFactorInput}
            placeholder={twoFaType === 'bzip' ? 'Zip Number' : 'Email'}
          />
        )}
        <TextInput
          type="text"
          onChange={handleChangeOrder}
          value={orderNumber}
          placeholder={language['returns.items.multi_item_form.placeholder']}
        />
        <Submit s={outline()} big onClick={handleSubmit} className="narvar-btn-secondary">
          {language['returns.items.multi_item_form.submit']}
        </Submit>
      </FormInnerWrapper>
    </FormOuterWrapper>
  );
};

export const FormContent = connect(mapStateToProps)(FormContentComponent);

FormContentComponent.propTypes = {
  language: PropTypes.object.isRequired,
  showTwoFa: PropTypes.bool.isRequired,
  handleChangeTwoFa: PropTypes.func.isRequired,
  secondFactorInput: PropTypes.string.isRequired,
  twoFaType: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
  orderNumber: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

FormContentComponent.defaultProps = {
  loading: false,
};
